// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import apiFun from "@/http/api.js";
// 引入 我们准备好的 store
import store from '@/store/index.js'
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css'
// Vue.use(ElementUI);
import  "amfe-flexible";
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

// 全局注册
Vue.prototype.$apiFun = apiFun;//请求接口api

if(!localStorage.getItem('thislang')){
  localStorage.setItem('thislang', 'zh-cn');
}
let __checklang = localStorage.getItem('checklang');
if (__checklang) {
  Vue.prototype.$langmsg = JSON.parse(__checklang);
} else {
  Vue.prototype.$langmsg = {};
}

Vue.config.productionTip = false

router.afterEach((to, from, next) => {
  
  window.scrollTo(0, 0);//每到一个新的页面 就自动回顶
  if(document.querySelector(".index-page")){
    document.querySelector(".index-page").scrollTo(0, 0) ;//

  }
});
router.beforeEach((to, from, next) => {
  // 没有语言包先请求再跳转
  let __cl = localStorage.getItem('checklang');
  if (!__cl || __cl === 'null' || __cl === '{}' || __cl === 'undefined' || (function(){try{let o=JSON.parse(__cl);return !o||Object.keys(o).length===0;}catch(e){return true;}})()) {
    fetch('https://www.gsh6686.top/api/getlangarray', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ lang: localStorage.getItem('thislang') || 'zh-cn' })
    }).then(r => r.json()).then(res => {
      if (res.code == 200) {
        localStorage.setItem('checklang', JSON.stringify(res.data));
        Vue.prototype.$langmsg = res.data;
      }
      next();
    }).catch(() => next());
    return;
  }
  // 确保 $langmsg 有值
  if (!Vue.prototype.$langmsg || Object.keys(Vue.prototype.$langmsg).length === 0) {
    Vue.prototype.$langmsg = JSON.parse(localStorage.getItem('checklang'));
  }
  let token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : '';
  if (to.matched.some(res => res.meta.requireAuth)) {
    if (sessionStorage.getItem('token')) {
      next();
    } else {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      });
    }
  } else {
    next();
  }
});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,//使用store
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js